// extracted by mini-css-extract-plugin
module.exports = {"locked-nfts-container":"PrivatePurchases_locked-nfts-container__2Tv1e","private-text":"PrivatePurchases_private-text__3spmL"};